import { useState } from "react";

interface IPaginationProps<T> {
  items: T[];
  itemsPerPage: number;
}

export default function useOffsetPagination<T = any>(props: IPaginationProps<T>) {
  const [currentPage, setCurrentPage] = useState<number>(0);

  const offsetStart = currentPage;
  const offsetEnd = currentPage + props.itemsPerPage;

  const hasNextPage = offsetEnd < props.items.length;
  const hasPreviousPage = currentPage > 0;

  return {
    items: props.items,
    itemsPerPage: props.itemsPerPage,
    currentItems: [...props.items].slice(offsetStart, offsetEnd),
    hasNextPage,
    hasPreviousPage,
    goToNextPage: () => setCurrentPage(hasNextPage ? currentPage + 1 : currentPage),
    goToPreviousPage: () => setCurrentPage(hasPreviousPage ? currentPage - 1 : currentPage),
  };
}
